/**
 * Created by wangjun on 2019/6/16.
 */
import { EventEmitter } from 'eventemitter3';

export const Event = new EventEmitter();


//status
export function selectorsStatus(value) {
  let status = null;
  return (value)=>{
    if(value) {
      status = value;
      return true;
    }else{
      let res = status;
      status = null;
      return res;
    }
  }
}

export const defaultSelectors = selectorsStatus();